import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools, Stripe } from '../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer } from '../Reusable'

import FadeIn from 'react-fade-in';
import PayoutsList from '../Admin/Payouts/PayoutsList' 
import UnpaidOrdersList from '../Admin/Payouts/UnpaidOrdersList' 
 
const { useHistory } = require('react-router-dom')

interface Props {
  
}
const ProPayoutsScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const user = useSelector(state => state.authReducer.user)
  const [error, setError] = React.useState('')

  return (
    <div className="wrapper">
      <Headerbar
        title={'Virements'}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            <FadeIn>

              <UnpaidOrdersList pro={user} />

              <PayoutsList
                title='Historique des virements'
                proId={user.id}
                onSelect={(item: any) => void 0}
                onCreate={() => void 0}
                />

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProPayoutsScreen